package uz.ferro.shop.model

import kotlinx.serialization.Serializable

@Serializable
data class FavoriteItemsInfo(
    val favoriteItems: List<FavoriteItem> = emptyList()
)